<template>
  <div>
    <photo-editor-modal :show="showModal" ref="imageEditor"/>


    <div class="container sidebar2-head">
          <div class="col float-left side2-h" v-bind:class = "(isBarShow) ? 'active' : ''" @click="isBarShow = true"  tabindex="1" id="bar1">Eigenschaften</div>
          <div class="col float-right  side2-h"  v-bind:class = "(isBarShow) ? '' : 'active'"  @click="isBarShow = false" tabindex="2" id="bar2">Schlagworte</div>
    </div>


<!--     <form v-on:submit.prevent="updateMultiplePhotosDescription">-->
     <ul class="sidebar2-li pb-5" v-if="isDetailsImagesSelectable" v-show="isBarShow" id="bar1-data11" style="height: calc(100vh - 225px);">
       <li>
         <h5 class="mb-2"> {{$t("photo_id")}} </h5>
         <strong v-for="img in selectedImages" :key="img.id">
           {{img.runid}}
         </strong>
      </li>
       <li>
        <h6 class="mb-2 photodescription">{{$t("photodescription")}}</h6>
        <textarea class="form-control" :readonly="!isEdit" v-model="multiDescription" rows="4" cols="26" @keyup="setDirtyText"></textarea>
      </li>
      <li v-if="isEdit" >
        <div class="col-md-12">
          <div class="row">
            <div class="col-sm-6 text-left pl-0">
              <input type="radio" v-model="descriptionOption" :checked="descriptionOption=='add'" name="save_as" value="add" class="btn-radio" id="add" required>
              <label for="add">
                <strong>{{$t("add")}}</strong>
              </label>
            </div>
            <div class="col-sm-6 text-left">
              <input type="radio" v-model="descriptionOption" :checked="descriptionOption=='replace'" name="save_as" value="replace" class="btn-radio" id="replace" required>
              <label for="replace">
              <strong> {{$t('replace')}} </strong>
              </label>
            </div>
          </div>
        </div>
      </li>
<!--      <li v-if="isEdit && isDetailsImagesSelectable" class="text-right border-0 savesingle_A">-->
<!--        <button class="btn btn-light btn-sm" type="reset">-->
<!--          {{$t("cancel")}}-->
<!--        </button>-->
<!--        <button class="btn btn-light active btn-sm" type="submit">-->
<!--          {{$t("save")}}-->
<!--        </button>-->
<!--      </li>-->
    </ul>
<!--     </form>-->
    <ul class="sidebar2-li" style="padding-bottom: 55px !important; box-sizing: border-box; " v-if="!isDetailsImagesSelectable" v-show="isBarShow" id="bar1-data">
<!--      height: calc(100vh - 225px);-->
      <li>
        <div class="row px-0">
          <div class="col-sm-6">
            <h6> {{$t("photo_id")}} </h6>
            <span  v-html="image.runid"></span>
          </div>
          <div class="col-sm-6">
            <h6>Tagesdoku</h6>
            <span>
              <div class="switch new d-inline pr-1">
                <label class="mb-0" for="daildocu_enabled">
                  <input type="checkbox" @change="setDirtyDailydocu" id="daildocu_enabled" v-model="image.dailydocu" value="1" :disabled="!isEdit">
                  <span class="lever mr-0 mt-0"></span>
<!--                  <strong class="pl-1">Tagedokumentation</strong>-->
                </label>
              </div>
            </span>

          </div>
        </div>
      </li>
      <li>
        <h6>{{$t("date")}}</h6>
        <span v-html="image.photodateBydot"></span>
      </li>
      <li>
        <h6>{{$t("file_name")}}</h6>
        <span v-html="image.origname"></span>
      </li>
      <li>
        <h6>{{$t("creator")}}</h6>
        <span>{{this.getImageUser(image.pduserid)}}</span>
      </li>

      <li v-if="imageDetails.plans" v-for="plan in imageDetails.plans" >
        <h6>{{$t("plan")}}</h6>
        <span>{{plan.planname}}</span>
        <div class="container" style="padding:0px;" >
          <img class="img-fluid border image mt-2"  :src="plan.src" alt="map">

<!--          getFlagsByImageAndPlanSync(image, plan) -->

          <template v-for="flag in plan.flags" >

            <div class="flagindetails"
                 style="position:absolute; background-color: red; border-radius: 100%; width:10px; height:10px; margin-left:-5px; margin-top:-5px;"
                 :style="{left: flag.left, top: flag.top}"
            ></div>

          </template>


<!--          <button type="button" class="btn btn-light btn-modal ml-1" data-toggle="modal" data-target=".planFlagModal" @click="setplanmodal(plan, plan.flags)">-->
<!--            ShowFlagOverlay-->
<!--          </button>-->

          <div class="overlay" data-toggle="modal" data-target=".planFlagModal" @click="setplanmodal(plan, image)">
            <div class="text">   {{ $t("open_plan_view") }} </div>
          </div>

<!--          <div class="overlay" @click="goToPlan(plan)">-->
<!--            <div class="text">   {{ $t("open_plan_view") }} </div>-->
<!--          </div>-->
        </div>
      </li>
      <li v-if="!imageDetails.plans">
        <h5>Pläne werden gesucht</h5>
      </li>
      <li>
        <h6>{{$t("voice_memo")}}</h6>

        <template  v-if="imagememos" v-for="memo in imagememos">
          <label class="memo-label" >
            vom: {{ memo.created | toDEDate() }}
          </label>
          <audio :src="getAudioUrl(memo)" preload="auto" controls  style="width: 100%;height: 25px;">
            Your browser does not support the audio element.
          </audio>
        </template>

      </li>
      <li v-if="!image.memos">
        <h5>No Memos Found</h5>
      </li>
<!--      <li>-->
<!--        <h6>{{$t("key_words")}}</h6>-->
<!--        <div class="mb-2" v-if="imageDetails.tags && imageDetails.tags.length > 0">-->
<!--          <button type="button" class="btn btn-light active radius-20"  v-for="tag in tags">-->
<!--            {{tag}}-->
<!--          </button>-->
<!--        </div>-->
<!--        <h5 v-else> No Tags Found</h5>-->
<!--      </li>-->

      <li>
        <h6 class="mb-2">{{$t("photodescription")}}</h6>
        <textarea :readonly="!isEdit" class="form-control"  rows="4" cols="26" v-model="image.description" @keyup="setDirtyText"></textarea>

        <button  v-if="isEdit" class="btn btn-primary mt-3 w-100" style="line-height: 1.9" data-toggle="modal" data-target=".bd-example-modal-lg" @click="setImageInEditor(image)">
        <i class="fa fa-edit pr-1"></i>   Im Foto zeichnen
        </button>
      </li>

<!--      <li v-if="isEdit" class="text-right border-0 savesingle_B" style="display: none">-->
<!--        <button class="btn btn-danger btn-sm">-->
<!--          {{$t("cancel")}}-->
<!--        </button>-->
<!--        <button class="btn btn-primary btn-sm" @click="updateDescription">-->
<!--          {{$t("save")}}-->
<!--        </button>-->
<!--      </li>-->
    </ul>

    <div class="sidebar2-li" style="padding-bottom: 55px !important; box-sizing: border-box;" id="side-img-details" v-show="!isBarShow">
<!--      height: calc(100vh - 225px);-->

      <ul id="accordion-right" class="accordion-style pb-5">
<!-- Taggroups => tags-->
        <li class="mb-3" v-for="taggroup in taggroups">
          <div class="" :id="'collapse-left-heading-'+ taggroup.projectparamid">

            <h5 class="mb-0 pos-rel">
              <a role="button" data-toggle="collapse" :href="'#collapse-left-tags-'+taggroup.projectparamid" aria-expanded="true" aria-controls="collapse-left-tags">
                {{ taggroup.group }}
              </a>
              <div class="switch switch-text">
                <label>
                  <input type="checkbox" v-model="selectedTags" :value=taggroup.projectparamid>
                </label>
              </div>
            </h5>

          </div>
          <div :id="'collapse-left-tags-'+taggroup.projectparamid" class="collapse show" data-parent="#accordion" aria-labelledby="collapse-left-heading-1">

            <template  v-for="tag in currentSystemTags">

              <template v-if="getTypeByParamtype(tag.type) === 'checkbox'">
                <div class="custom-control custom-checkbox " v-if="taggroup.group == tag.group">
                  <input
                       :type="getTypeByParamtype(tag.type)"
                       class="custom-control-input"
                       :disabled="!isEdit"
                       v-bind:checked="activeKeys[getIndex(activeKeys, tag.projectparamid)]"
                       v-on:click="tagsDetailCheckbox(tag, $event, tag.paramType)"
                       :id="'detailchild_'+tag.projectparamid"
                       :name="'dn_'+tag.projectparamid">
                  <label class="custom-control-label custom-label" v-bind:for="'detailchild_'+tag.projectparamid">{{tag.name}} </label>
                </div>
              </template>
              <template v-if="getTypeByParamtype(tag.type) === 'text'">
                <div class="custom-control custom-text " style="margin-left: -19px;" v-if="taggroup.group == tag.group">
                  <input
                         :type="getTypeByParamtype(tag.type)"
                         class="form-control-sm sm-input enterblur"
                         :disabled="!isEdit"
                         :checked="activeKeys[getIndex(activeKeys, tag.projectparamid)]"
                         :value="getTextValue(activeKeys[getIndex(activeKeys, tag.projectparamid)]).value"
                         v-on:blur="tagsDetailCheckbox(tag, $event, tag.paramType)"
                         :id="'detailchild_text_'+tag.projectparamid"
                         :name="'dnt_'+tag.projectparamid">
                  <label class="font-10" v-bind:for="'detailchild_text_'+tag.projectparamid">{{tag.name}} </label>
                </div>
              </template>
            </template>
          </div>
        </li>

<!--        <li v-if="isEdit && isSelecteAble" class="border-bottom">-->
        <li v-if="isEdit && isDetailsImagesSelectable" class="border-bottom">
          <form>
          <div class="col-md-12 mt-2">
            <div class="row">
              <div class="col-sm-5 text-left">
                <input type="radio" id="adde" v-model="tagsOption" name="tags_save_as" value="add" class="btn-radio" required>
                <label for="adde">
                  <strong>{{$t("add")}}</strong>
                </label>
              </div>
              <div class="col-sm-6 text-left pl-0">
                <input type="radio" id="replace11" v-model="tagsOption" name="tags_save_as" value="remove" class="btn-radio" required>
                <label for="replace11">
                  <strong>{{$t('remove')}}</strong>
                </label>
              </div>
            </div>
          </div>
          </form>
        </li>
      </ul>
    </div>

    <div style="position: relative; background-color: #FFF; z-index:10; position: absolute; bottom: 0px; right:0px; width: 100%; height:55px;">
      <ul style="padding:10px;">
        <li v-if="!isDetailsImagesSelectable && isEdit && (dirtyblocks.textbox || dirtyblocks.tags || dirtyblocks.dailydocu)" class="text-right border-0 savesingle_C" >
          <button class="btn btn-danger btn-sm" @click="abbortAction" >
            {{$t("cancel")}}
          </button>
          <button class="btn btn-primary btn-sm" @click="updateDescription">
            {{$t("save")}}
          </button>
        </li>
        <li v-if="isEdit && isDetailsImagesSelectable && (dirtyblocks.textbox || dirtyblocks.tags || dirtyblocks.dailydocu)" class="text-right border-0 savesingle_A">
          <button class="btn btn-danger btn-sm" @click="abbortAction" type="reset" >
            {{$t("cancel")}}
          </button>
          <button class="btn btn-primary btn-sm" type="submit" @click="updateMultiplePhotosDescription" v-if="dirtyblocks.textbox || dirtyblocks.tags || dirtyblocks.dailydocu">
            {{$t("save")}}
          </button>
        </li>
      </ul>
    </div>



  </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import moment from 'moment'
import PhotoEditorModal from './PhotoEditorModal'
export default {
  name: 'DetailsFilters',
  data () {
    return {
      isBarShow: true,
      descriptionOption: 'add',
      multiDescription: '',
      multiTags: [],
      multiTagsTest: [],
      tagsOption: 'add',
      selectedTags: [],
      detailtagskeys: [],
      detailtags: [],
      imageTags: [],
      temptags: [],
      maintenance: true,
      currentphotoflags: [],
      showModal: false,
      dirtyblocks: {
        textbox: false,
        tags: false,
        dailydocu: false,
        multiDescription: false
      }
    }
  },
  components: {
   PhotoEditorModal
  },
  filters: {
    toDEDate: function(string) {
      return moment(string).format('DD.MM.YYYY HH:mm:ss')
    }
  },
  created() {
    this.getUsers()
  },
  methods: {

    setDirtyText() {
      this.isDirty = true
      this.dirtyblocks.textbox = true
    },
    setDirtyTags() {
      this.isDirty = true
      this.dirtyblocks.tags = true
    },
    setDirtyDailydocu() {
      this.isDirty = true
      this.dirtyblocks.dailydocu = true
    },
    setplanmodal(plan, image) {
      this.$store.state.photo.planmodal = {
        plan: plan,
        image: image
      }
    },

    setImageInEditor(photo){
      this.$refs.imageEditor.getLargeImage(photo);
      this.showModal = true;
    },

    getFlagsByImageAndPlan(image, plan) {
      let _this = this

      console.log('Find image and plan', image, plan)

      return axios.post(process.env.VUE_APP_BASE_AMF_URL + `getFlagsOfPhotoAndPlan&token=` + localStorage.sessiontoken,
        {
        "methodName": "getFlagsOfProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id,
          10000,
          0,
          {
            'operands': [{
              "fieldname": "pdplanid",
              "fieldvalue": plan.pdplanid,
              "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
            }, {
              "fieldname": "pdphotoid",
              "fieldvalue": image.pdphotoid,
              "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
            }],
            "_explicitType": "com\\projectdocu\\PredicateOperatorAndVO"
          },
          [{
            "fieldname": "runid",
            "order": "DESC",
            "_explicitType": "com\\projectdocu\\OrderSettingVO"
          }]
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
      .then((response) => {
        if (response.status == 200) {

          let img = new Image()
          img.src = plan.src
          let width = img.width
          let height = img.height


          if(width > height) {
            let ratio =  5000 / width
            height = ratio*height
            width = 5000
          } else {
            let ratio = 5000/ height
            height = 5000
            width = width*ratio
          }

          let widthadd = width / 2
          let heightadd = height / 2


          let tempflags = response.data.flags
          let result = []
          if(tempflags.length) {
            tempflags.forEach(function(val, idx) {
              let fx = parseFloat(val.xcoord + widthadd)
              let fy = parseFloat(val.ycoord + heightadd)
              let afx = parseFloat(val.viewx + widthadd)
              let afy = parseFloat(val.viewy + heightadd)

              let left = ( (fx / width) * 100)
              let top = ((fy / height) * 100)
              let aleft = ( ( ( fx + val.viewx ) / width) * 100)
              let atop = ( ( ( fy + val.viewy ) / height) * 100)

              result.push({
                'left': left + '%',
                'top': top + '%',
                'aleft': aleft + '%',
                'atop': atop + '%',
                'val.xcoord': val.xcoord,
                'val.ycoord': val.ycoord,
                'width': width,
                'height': height,
                'fx': fx,
                'fy':fy,
                'afx':afx,
                'afy':afy,
                'viewx':val.viewx,
                'viewy':val.viewy
              })
            })
          }


          plan.flags = result

          _this.$forceUpdate()
          return result

        }
      })

      // .catch(error => console.log(error))
      // .finally(() => {
      //
      // })
      //
      // console.log('Flags from System', flags)
      // //
      // // flags.push({
      // //   'left': '25%',
      // //   'top': '25%'
      // // })
      //
      // return flags

    },


    goToPlan(plan) {
      this.$store.state.photo.gottoplan = plan
      this.$store.commit('setMapView')
    },


    getAudioUrl (memo) {
      let url = process.env.VUE_APP_BASE_URL + memo.path + '&token=' + localStorage.sessiontoken
      return url
    },


    getTypeByParamtype: function(ptype) {
      if(ptype === '0') {
        return 'checkbox'
      } else {
        return 'text'
      }
    },

    tagsDetailCheckboxSingle: function(index, event, paramType) {

      let temp = []
      let _this = this
      let add = true
      let element = index

      console.log('tags Detail Checkbox Single Check', index, event)

      if(event.target.type == "checkbox" && index.type == "0") {
        // is checkbox
        _this.image.params.forEach(function(val, idx) {
          if(val.projectparamid == index.projectparamid) {
            _this.image.params.splice(idx, 1)
            add = false
          }
        })

        if(add) {
          element.value = event.target.checked
          this.image.params.push(element)
        }

        console.log('Set Checkbox Final', this.image.params)

      } else if(event.target.type == "text"  && index.type == "1") {

        if(event.target.value != element.projectparamid && event.target.value == '') {
          // Remove if exists

          _this.image.params.forEach(function(val, idx) {
            if(val.projectparamid == index.projectparamid) {
              if(idx >= 0) {
                _this.image.params.splice(idx, 1)
              }
            }
          })
          add = false
        }

        if(add) {
          element.value = event.target.value

          if(event.target.value != element.projectparamid && event.target.value != '') {
            let keyidx = _this.image.params.findIndex((activekey) => activekey.projectparamid == element.projectparamid)
            if(keyidx >= 0) {
              _this.image.params[keyidx].value = event.target.value
            } else {
              _this.image.params.push(element)
            }
          }
        }
      }

      _this.activeKeys = _this.image.params
      // _this.detailtagskeys = temp


    },

    tagsDetailCheckbox: function (index, event, paramType) {

      let _this = this
      let element = index
      let add = true

      console.log('SetCheckbox', index, event, paramType)

      if(!this.isDetailsImagesSelectable) {
        this.tagsDetailCheckboxSingle(index, event, paramType)
      } else {

        if(event.target.type == "checkbox" && index.type == "0") {
          // is checkbox
          _this.multiTags.forEach(function(val, idx) {
            if(val.projectparamid == index.projectparamid) {
              _this.multiTags.splice(idx, 1)
              add = false
            }
          })

          if(add) {
            element.value = event.target.checked
            this.multiTags.push(element)
          }

        } else if(event.target.type == "text"  && index.type == "1") {
          // Feldtyp = Text
          if(event.target.value != element.projectparamid && event.target.value == '') {
            // Remove if exists

            _this.multiTags.forEach(function(val, idx) {
              if(val.projectparamid == index.projectparamid) {
                if(idx >= 0) {
                  _this.multiTags.splice(idx, 1)
                }
              }
            })
            add = false
          }

          if(add) {
            element.value = event.target.value

            if(event.target.value != element.projectparamid && event.target.value != '') {
              let keyidx = _this.multiTags.findIndex((activekey) => activekey.projectparamid == element.projectparamid)
              if(keyidx >= 0) {
                _this.multiTags[keyidx].value = event.target.value
              } else {
                _this.multiTags.push(element)
              }
            }
          }
        }

        console.log('Res', {
          'event.target.type': event.target.type,
          'index.type': index.type,
          'Element': element,
          'Event': event,
          'ActiveKeys': _this.activeKeys,
          'Event Checked' :event.target.checked
        })


      }

      this.dirtyblocks.tags = true
      this.isDirty = true


    },

    getTextValue: function(el) {


      if(el !== undefined) {
        return el
      }

      return {value: ''};

    },

    getSessionToken() {
      return localStorage.sessiontoken
    },

    async getUsers() {


      let ret = await axios.post(process.env.VUE_APP_BASE_AMF_URL + `getUsers&token=` + localStorage.sessiontoken, {
        "methodName": "getUsersOfProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      })
        .then(response => {
          if (response.status == 200) {
            this.$store.users = response.data
          }
        })
        .catch(error => console.log(error))
        .finally(() => {

          $('.spinner-cover').hide()
        })
    },
    getImageUser(pduserid) {

      if(typeof(this.$store.users) != 'object') {
        this.getUsers()
      }


      let currentusername = 'Unknown'
      if(this.$store.users) {
        this.$store.users.forEach(function(val, ind) {
          if(val.pduserid == pduserid) {
            currentusername = val.firstname + ' ' + val.lastname + '(' + val.email + ')'
          }
        })
      }

      return currentusername
    },

    getCurrentPhotoTags: function() {
      return this.$store.state.photo.tags
    },



    // Update image Description
    updateDescription () {

      console.log('Update Photo Params', this.image.params)

      let current_image = this.$store.state.photo.active_image
      let now = new Date()
      let data = {
        methodName: 'UpdatePhoto',
        serviceName: 'ProjectdocuService',
        parameters: [
          this.image.pdphotoid,
          {
            // photodate: this.formatSaveDate(this.image.photodate),
            // exifhasgps: this.image.exifhasgps,
            // exifgpsx: this.image.exifgpsx,
            // exifgpsy: this.image.exifgpsy,
            // exifdate: this.image.exifdate,
            // exifhasgpsdirection: this.image.exifhasgpsdirection,
            // exifgpsdirection: this.image.exifgpsdirection,
            // gpsaccuracy: this.image.gpsaccuracy,
            pdphotoid: this.image.pdphotoid,
            projectid: this.image.projectid,
            description: this.image.description,
            dailydocu: this.image.dailydocu,
            params: this.activeKeys,
            savedate: this.formatSaveDate(now),
            _explicitType: "com\\projectdocu\\PhotoVO"
          }
        ]
      }
      this.$store.dispatch('updatePhotoDescription', data)

      this.$store.state.photo.activeImageCopy.description = this.image.description
      // state.active_image.taggroups = {...state.activeImageCopy.taggroups}
      this.$store.state.photo.activeImageCopy.params = this.activeKeys
      this.dirtyblocks = {textbox: false, tags: false}
      this.isDirty = false
    },

    // Update Or Replace Multiple Photos Description
    async updateMultiplePhotosDescription () {

      let _this = this

      let data = {
        id: this.$route.params.id,
        option: this.descriptionOption,
        description: this.multiDescription,
        tags: this.multiTags,
        tagsOption: this.tagsOption
      }
      await this.$store.dispatch('updateMultiPhotoDescription', data)

      // this.$store.state.photo.active_image = this.$store.state.photo.detailsSelectedImages[0]
      // this.$store.state.photo.detailsSelectedImages = []
      this.isDetailsImagesSelectable = false
      this.dirtyblocks = {textbox: false, tags: false}
      this.isDirty = false
      this.multiDescription = ''
    },


    formatSaveDate (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD hh:mm:ss')
      }
    },

    formatDateByDash (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },

    formatDateByTime (value) {
      if (value) {
        return moment(String(value)).format('hh:mm:ss')
      }
    },

    getIndex(list, id) {
      let it =  list.findIndex((e) => e.projectparamid == id)
      return it

    },

    abbortAction() {

      if(this.isDetailsImagesSelectable) {

        console.log('abbortAction multiple')
        // Clear Stack
        // this.$store.state.photo.detailsSelectedImages.splice(0);
        this.$store.state.photo.active_image = this.$store.state.photo.detailsSelectedImages[0]
        this.$store.state.photo.detailsSelectedImages = []
        // this.isDetailsImagesSelectable = false
        this.$store.state.photo.isDetailsImagesSelectable = false
        this.multiDescription = ''
        this.activeKeys = []
        setTimeout(function() {
          $('.activeImg').trigger('click')
        }, 500)
        this.dirtyblocks = {textbox: false, tags: false, dailydocu: false}
        this.isDirty = false
      } else {
        console.log('abbortAction single')
        // Reload COPY
        this.image.description = this.imageCopy.description
        this.image.params = [].slice.call(this.imageCopy.params)
        this.activeKeys = [].slice.call(this.imageCopy.params)
        this.image.dailydocu = this.imageCopy.dailydocu
        this.dirtyblocks = {textbox: false, tags: false, dailydocu: false}
        this.isDirty = false
      }

      // this.$store.state.photo.isEdit = false
    }
  },
  computed: {
    ...mapState({
      selectedImages: state => state.photo.detailsSelectedImages,
      isSelecteAble: state => state.photo.isBottomNav,
      isDetailsImagesSelectable: state => state.photo.isDetailsImagesSelectable,
      isEdit: state => state.photo.isEdit,
      photos: state => state.photo.photos,
      projecttags: state => state.photo.projecttags
    }),
    imageDetails () {
      return this.$store.state.photo.imageDetails
    },
    image() {
        return this.$store.state.photo.active_image
    },
    imageCopy() {
        return this.$store.state.photo.activeImageCopy
    },
    imagememos () {
      return this.$store.state.photo.active_image.memos
    },

    taggroups: {
      get() {
        return this.$store.state.photo.taggroups
      },
      set(val) {
      }
    },

    isDirty: {
      get() {
        return this.$store.state.photo.dirty
      },
      set(val) {
        this.$store.state.photo.dirty = val
      }
    },

    currentSystemTags: {
      get() {
        return this.$store.state.photo.tags
      },
      set(val) {
        console.log('setCurrentSystemTags', this.$store.state.photo.tags)
      }
    },
    currentPhotoTags: {
      get() {
        return this.$store.state.photo.tags
      },
      set(val) {}
    },

    activeKeys: {
      get() {

        let temp = []


        if (this.isDetailsImagesSelectable) {
          this.multiTags.forEach(function(val, idx) {
            if(idx == -1) {
            } else {
              temp.push(val)
            }
          })

          return temp
        } else {
          if(Array.isArray(this.image.params)) {
            this.image.params.forEach(function(val, idx) {
              if(idx == -1) {

              } else {
                temp.push(val)
              }
            })
          }
        }
        console.log('GetActiveKeys', temp)

        return temp

      },
      set(val) {
        console.log('Set Current Value', val)
      }
    },

    addTagToImage: function() {
      let _this = this
    },


    // get & Set Tags Value
    // tags: {
    //   get () {
    //     if (this.isDetailsImagesSelectable) {
    //       console.log('Get Tags')
    //       return this.multiTags
    //     } else {
    //       return this.imageDetails.tags && (!Array.isArray(this.imageDetails.tags)) ? this.imageDetails.tags.split(',') : []
    //     }
    //   },
    //   set (val) {
    //     console.log('Set Tags', val)
    //     if (this.isDetailsImagesSelectable) {
    //       // this.multiTags = val
    //     } else {
    //       // this.imageDetails.tags = val.toString()
    //     }
    //   }
    // }
  },
  watch: {
    selectedImages: function(value) {

    },

    // 'image.dailydocu': function() {
    //   console.log('Image Dailydocu changed')
    //   this.setDirtyDailydocu()
    // },


    '$store.state.photo.actionTrigger': function() {
      let _this = this

      this.$store.state.photo.actionTrigger.forEach(function(val, idx) {
        console.log('Action to trigger', val)
        if(val == 'DetailsFilter.abbortAction') {
          _this.abbortAction()
          _this.$store.state.photo.actionTrigger.splice(idx, 1)
        }
      });

    },
    imageDetails: function(value) {
      let _this = this

      if(this.imageDetails.plans != undefined && this.imageDetails.plans.length) {
        this.imageDetails.plans.forEach(function(plan, idx) {
          _this.getFlagsByImageAndPlan(_this.image, plan)
        })

      }
    },

    image: function(value) {

      this.$store.state.photo.imageDetails = {}
    },
    activeKeys: function(value) {
      console.log('activeKeys changed', value)
      this.descriptionOption = this.descriptionOption
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
}

img.image {
  display: block;
  width: 100%;
  height: auto;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  transition: .5s ease;
  background-color: #0000008c
}

.container:hover .overlay {
  opacity: 1;
}

.text {
  color: white;
  font-size: 12px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}
.sidebar2-li{
  height: calc(100vh - 195px);
  overflow-y: auto !important;
}
.btn-radio{
  width: 20px;
}
button.btn-sm{
  line-height: 35px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/photo/components/DetailsFilters.vue